import React, { Component } from 'react';

class NameAge extends Component {
	render() {
		return (
			<section className="assessment bg name__age">
				<div className="container-fluid">
					<h1 className="assessment__heading">What’s your Name?</h1>
					<div className="name__age--field">
						<input className="form-control" type="text" placeholder="Name" name="" />
					</div>
					<h1 className="assessment__heading">What is your Age?</h1>
					<div className="name__age--badges">
						<span>  20</span>
						<span>21 - 30</span>
						<span>31 - 40</span>
						<span>41 - 50</span>
						<span>50 ></span>
					</div>
				</div>
			</section>
		);
	}
}


export default NameAge;